
export const isFavorited = state => ({item}) => {
  return state.favorites.indexOf(item.key) !== -1
}



// WEBPACK FOOTER //
// ./src/store/getters.js